var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCreateRoadblock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6543 10.8158H2.3464L1.6044 13.0263H0V14.5H14V13.0263H12.3956L11.6543 10.8158ZM2.8399 9.3421H11.1601L10.1717 6.39474H3.8283L2.8399 9.3421ZM7.7 0.5H6.3C6.15519 0.499989 6.01395 0.547251 5.89572 0.635273C5.7775 0.723295 5.68812 0.847745 5.6399 0.991474L4.3225 4.92105H9.6775L8.3601 0.991474C8.31188 0.847745 8.2225 0.723295 8.10428 0.635273C7.98605 0.547251 7.84481 0.499989 7.7 0.5Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCreateRoadblock);
export default __webpack_public_path__ + "static/media/icon--create-roadblock.6cf9c9a9b1ccd649bd0505ceebe9b9cb.svg";
export { ForwardRef as ReactComponent };